<app-card [hidHeader]="true" [contentType]="'prizes'">
    <div class="row">
        <div class="col-12 col-md-3" *ngFor="let prize of prizes">
            <div class="card mb-3">
                <div class="image-wrapper" *ngIf="prize.image" [routerLink]="['./' + prize.id]" [style.backgroundImage]="'url(' + environment.imageCDN + environment.imageFolder + '/' + prize.image +')'"></div>
                <div class="image-wrapper" *ngIf="!prize.image" [routerLink]="['./' + prize.id]" [style.backgroundImage]="'url(\'/assets/images/prize_placeholder.png\')'"></div>
                <div class="card-body">
                    <h5 class="card-title" [routerLink]="['./' + prize.id]">{{prize.title}}</h5>
                    <p class="card-text">{{ prize.description.length > 100 ? (prize.description | slice:0:100) + '..' : prize.description}}</p>
                    <small class="btn btn-outline-primary btn-sm d-inline-block" [routerLink]="['./' + prize.id]">Modifica</small>
                    <small (click)="deleteModal.show(); prizeSelected = prize" class="btn btn-sm text-danger btn-link">elimina</small>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-3">
            <div class="add-new-card" [routerLink]="['./new']">
                <span>AGGIUNGI NUOVO PRIZE</span>
            </div>
        </div>
        <div class="col-12" *ngIf="lastExp">
            <p><a href="javascript:;" [routerLink]="['/experiences', lastExp.id]">Torna a completare l'experience {{lastExp.title}}</a></p>
        </div>
    </div>
</app-card>

<app-ui-modal #deleteModal dialogClass="modal-dialog-centered">
    <div class="app-modal-header">
    <h5 class="modal-title">Sicuro di voler eliminare?</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="deleteModal.hide()"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="app-modal-body">
        <p>
            Eliminando "{{prizeSelected?.title}}"" perderai tutti i dati relativi.
        </p>
    </div>
    <div class="app-modal-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="deleteModal.hide();">Annulla</button>
    <button type="button" class="btn btn-primary" (click)="deleteModal.hide(); this.deletePrize(prizeSelected?.id);">Elimina</button>
    </div>
</app-ui-modal>
